import { Emitter, EventType } from 'mitt';
import mitt from 'mitt';

declare type Handler<T = Map<string, unknown>> = (event: T) => void;

class PlayerEmitter {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly emitter: Emitter<Record<EventType, any>>;

  constructor() {
    this.emitter = mitt();
  }

  emit(eventType: EventType, data?: Iterable<readonly [string, unknown]>): void {
    if (!data) {
      this.emitter.emit(eventType);
    } else {
      this.emitter.emit(eventType, new Map<string, unknown>(data));
    }
  }

  on(eventType: EventType, handler: Handler): void {
    this.emitter.on(eventType, handler);
  }
}

export default PlayerEmitter;
